import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import { MobileTabBar } from './components/MobileTabBar';
import { HomePage } from './pages/HomePage';
import { ExplorePage } from './pages/ExplorePage';
import { CategoryPage } from './pages/CategoryPage';
import { ProductListingPage } from './pages/ProductListingPage';
import { OfferDetailPage } from './pages/OfferDetailPage';
import { AccountPage } from './pages/AccountPage';
import { LinkCardPage } from './pages/LinkCardPage';
import { HistoryPage } from './pages/HistoryPage';
import { FavoritesPage } from './pages/FavoritesPage';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen bg-gray-50 font-sans text-gray-900 flex" data-id="element-1">
        {/* Left Sidebar Navigation (Desktop) */}
        <Sidebar data-id="element-2" />

        {/* Main Content Area */}
        <main className="flex-1 md:ml-20 min-h-screen relative" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/explore" element={<ExplorePage data-id="element-8" />} data-id="element-7" />
            <Route path="/category/*" element={<CategoryPage data-id="element-10" />} data-id="element-9" />
            <Route path="/products/*" element={<ProductListingPage data-id="element-12" />} data-id="element-11" />
            <Route path="/offers/:id" element={<OfferDetailPage data-id="element-14" />} data-id="element-13" />
            <Route path="/account" element={<AccountPage data-id="element-16" />} data-id="element-15" />
            <Route path="/link-card" element={<LinkCardPage data-id="element-18" />} data-id="element-17" />
            <Route path="/history" element={<HistoryPage data-id="element-20" />} data-id="element-19" />
            <Route path="/favorites" element={<FavoritesPage data-id="element-22" />} data-id="element-21" />
          </Routes>
        </main>

        {/* Mobile Bottom Tab Bar */}
        <MobileTabBar data-id="element-23" />
      </div>
    </Router>;
}